import { addDays, getNow } from 'model';

export const getDaysBackRange = (timeBack: string) => {
	return [addDays(getNow(), -timeBack), getNow()];
};
